import * as ActionTypes from '../../actions'
import {
    Action,
    TotalViolationsType
} from "../../types";
import areaChartConfig from "../../highchartsConfigDefault/areaChartConfig";

const defaultState = {
    totalViolationCount: 0,
    isLoading: true,
    hasError: false,
    chart: {}
};

export default function(state: TotalViolationsType = defaultState, action: Action) {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.FETCH_TOTAL_VIOLATIONS: {

            return {
                ...state,
                isLoading: true,
                hasError: false
            };
        }
        case ActionTypes.FETCH_TOTAL_VIOLATIONS_SUCCESS: {
            const { areaChart, totalViolationCount } = payload;
            const { series } = areaChart;

            return {
                isLoading: false,
                hasError: false,
                totalViolationCount,
                chart: {
                    area: {
                        config: areaChartConfig().initializeWithOptions({
                            chart: {
                                height: '140px'
                            },
                            series,
                            yAxis: {
                                gridLineWidth: 0
                            }
                        }),
                        show: true
                    }
                }
                
            };
        }
        case ActionTypes.FETCH_TOTAL_VIOLATIONS_MESSAGE: {
            const {violations_count, ts} = payload;
            const {chart, totalViolationCount} = state;

            if (chart && chart.area) {
                const area = chart.area;
                const series = area.config.series;
                let seriesData = series[0].data;
                const seriesPoint = {
                    x: ts * 1000, y: violations_count
                };

                seriesData.push(seriesPoint);
                // seriesData.shift();

                return {
                    // ...value,
                    isLoading: false,
                    hasError: false,
                    totalViolationCount: totalViolationCount + violations_count,
                    chart: {
                        area: {
                            config: areaChartConfig().initializeWithOptions({
                                chart: {
                                    height: '140px'
                                },
                                series,
                                tooltip: {
                                    enabled: true
                                }
                            }),
                            show: true
                        }
                    }
                };
            }
            return state;
        }
        case ActionTypes.FETCH_TOTAL_VIOLATIONS_FAILURE: {

            return {
                ...state,
                isLoading: false,
                hasError: true
            };
        }
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dashboard/totalViolations.ts